import { isScannerApp, scannerAppAllows } from "@/lib/scanner-app";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext, redirect } from "@tanstack/react-router";

/**
 * Root route. Mounts once for the whole app; every other route
 * renders inside its `<Outlet />`. The Next-side `(app)/layout.tsx`
 * does sidebar + auth gate + live-refresh, etc. — those will land
 * in this tree as nested routes in subsequent phases (auth on the
 * root, layout under an `_app` pathless route below the auth gate).
 *
 * `createRootRouteWithContext` lets every route loader/action see
 * the `queryClient` without having to import it directly — keeps
 * routes loosely coupled to the QueryClient instance.
 */
export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  beforeLoad: ({ location }) => {
    // The Netlion Scanner app shows the scanner only, even after the sign-in lands on `/`.
    if (isScannerApp(location.searchStr) && !scannerAppAllows(location.pathname)) {
      throw redirect({ to: "/scan" });
    }
  },
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
